// extracted by mini-css-extract-plugin
export default {"container":"styles_container__g83k0","image":"styles_image__QLkyJ","cards":"styles_cards__DVD4b","card":"styles_card__k81G6"};